'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTapEventPlugin = require('react-tap-event-plugin');

var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseGesturesSwipeable = require('@bibliocommons/base-gestures-swipeable');

var _baseGesturesSwipeable2 = _interopRequireDefault(_baseGesturesSwipeable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(0, _reactTapEventPlugin2.default)();

var Toggle = function (_BcReactComponent) {
  _inherits(Toggle, _BcReactComponent);

  function Toggle(props) {
    _classCallCheck(this, Toggle);

    var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));

    _this.bindAll('toggleDrawer');
    return _this;
  }

  _createClass(Toggle, [{
    key: 'toggleDrawer',
    value: function toggleDrawer(e) {
      e.preventDefault();
      this.props.drawerActions.toggle();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _baseGesturesSwipeable2.default,
        {
          onSwipedRight: this.toggleDrawer,
          className: 'cp-drawer-toggle hidden-lg' },
        _react2.default.createElement(
          'span',
          null,
          this.props.children
        )
      );
    }
  }]);

  return Toggle;
}(_baseBcReactComponent2.default);

Toggle.propTypes = {
  drawerActions: _react.PropTypes.shape({
    toggle: _react.PropTypes.func.isRequired
  })
};

exports.default = Toggle;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-drawer/lib/components/toggle/components/Toggle.component.js
// module id = 1069
// module chunks = 1